import { useEffect, useState } from "react"

export const TOUCH_PRIMARY_MEDIA_QUERY = "(hover: none) and (pointer: coarse)"

export const isTouchPrimaryDevice = (): boolean => {
  if (typeof window === "undefined") {
    return false
  }
  return window.matchMedia(TOUCH_PRIMARY_MEDIA_QUERY).matches
}

export const useTouchPrimary = (): boolean => {
  const [isTouchPrimary, setIsTouchPrimary] = useState(isTouchPrimaryDevice)

  useEffect(() => {
    const mediaQuery = window.matchMedia(TOUCH_PRIMARY_MEDIA_QUERY)
    const handleChange = () => setIsTouchPrimary(mediaQuery.matches)

    mediaQuery.addEventListener("change", handleChange)
    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [])

  return isTouchPrimary
}

export default useTouchPrimary
